export enum ContactPanelTabIds {
  CONVERSATION = "conversation",
  ACTIVITY_HISTORY = "activity-history",
  CONTACT_INFO = "contact-info",
}
